import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'
import useRouteParser from 'src/hooks/routeParser'
import { toInteger } from 'lodash'
const { toArrayOfInt, toFloat } = useRouteParser()

const { t } = useI18n()

const module: RouteRecordRawArgumented = {
  path: 'stock-offers',
  name: 'stockOffers',
  redirect: () => ({ name: 'stockOffersIndex' }),
  children: [
    {
      path: ':step?',
      name: 'stockOffersIndex',
      component: () =>
        import(
          /* webpackChunkName: "stock-offers-index" */ 'pages/stock-offers/IndexPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.stock_offers.index'),
          icon: 'mdi-package-up',
        },
        auth: {
          permission: 'stock_offers_view',
        },
        inject: {
          params: {
            step: 'select',
          },
          query: {
            cost: 'cmp_net_net',
            type: 'class',
          },
        },
        casts: {
          query: {
            warehouse: toArrayOfInt,
            class: toArrayOfInt,
            manufacturer: toArrayOfInt,
            group: toArrayOfInt,
            family: toArrayOfInt,
            threshold: toInteger,
            increase: toFloat,
          },
        },
      },
    },
  ],
}

export default module
